import { instantsInterceptor, } from '@/api/index';

function login(map) {
    return instantsInterceptor.post('/api/login', map);
}

function logout() {
    return instantsInterceptor.get('/api/logout');
}

function getUserDiv(map) {
	return instantsInterceptor.post('/api/userdiv', map);
}

function ssoLogin() {
    return instantsInterceptor.post('/api/login/token');
}

function checkSession() {
    return instantsInterceptor.get('/api/check/session');
}


export { login, logout, getUserDiv, ssoLogin, checkSession};